import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const AriaLiveDiv = styled.div`
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
`;

type Props = {
  messageId: string;
};

export const AriaLiveMessage: React.FC<Props> = ({ messageId }) => {
  return (
    <AriaLiveDiv aria-live="polite" aria-atomic="true">
      <FormattedMessage id={messageId} />
    </AriaLiveDiv>
  );
};
